import { useState } from "react";
import { Plus, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

export function LexiconForm({ onAdded }) {
  const [f, setF] = useState({ word: "", definition: "", example: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/teams/lexicon", f);
      toast.success(`« ${f.word} » ajouté au lexique`);
      setF({ word: "", definition: "", example: "" });
      onAdded();
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="bg-white rounded-2xl border-2 border-slate-200 p-4 space-y-3 rise" data-testid="lexicon-form">
      <p className="text-xs font-bold uppercase text-slate-500">Ajouter un mot de notre chantier</p>
      <Input value={f.word} onChange={set("word")} maxLength={60} required placeholder="Le mot (ex : la banche)" className="h-12 text-base" data-testid="lexicon-word-input" />
      <Textarea value={f.definition} onChange={set("definition")} maxLength={300} required placeholder="Définition simple" className="min-h-[70px] text-base" data-testid="lexicon-definition-input" />
      <Input value={f.example} onChange={set("example")} maxLength={300} placeholder="Exemple (facultatif)" className="h-12 text-base" data-testid="lexicon-example-input" />
      <button
        type="submit"
        disabled={busy || !f.word.trim() || f.definition.trim().length < 3}
        data-testid="lexicon-add-btn"
        className="w-full h-12 rounded-xl bg-orange-500 hover:bg-orange-600 text-white font-bold flex items-center justify-center gap-2 transition-colors disabled:opacity-40"
      >
        {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : <Plus className="w-5 h-5" />} Ajouter
      </button>
    </form>
  );
}
